import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=065a4baa"
import script from "./profile.ts?vue&type=script&lang=js&external"
export * from "./profile.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports